import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserLocationType } from '../schemas/teacherReg'
import { RootState } from './store'

interface PreRegistrationState {
    // accountType: AccountType | null | undefined
    teacherRole: 'school' | 'earlyChildcare' | 'supportStaff' | null
    institutionType: 'school' | 'childcareCentre' | null

    location?: UserLocationType
}

const initialState: PreRegistrationState = {
    teacherRole: null,
    institutionType: null,
}

const preRegistrationSlice = createSlice({
    name: 'preRegistration',
    initialState,
    reducers: {
        setPreRegInstitutionType: (
            state,
            action: PayloadAction<'school' | 'childcareCentre' | null>
        ) => {
            state.institutionType = action.payload
        },
        setPreRegTeacherRole: (
            state,
            action: PayloadAction<
                'school' | 'earlyChildcare' | 'supportStaff' | null
            >
        ) => {
            state.teacherRole = action.payload
        },
        // setPreRegAccountType: (
        //     state,
        //     action: PayloadAction<AccountType | null | undefined>
        // ) => {
        //     state.accountType = action.payload
        // },
        setPreRegLocation: (
            state,
            action: PayloadAction<UserLocationType | undefined>
        ) => {
            state.location = action.payload
        },
        resetPreRegistration: () => initialState,
    },
})

export const selectOnboardingSavedLocation = (state: RootState) =>
    state.preRegistration.location

export const {
    setPreRegInstitutionType,
    setPreRegTeacherRole,
    // setPreRegAccountType,
    setPreRegLocation,
    resetPreRegistration,
} = preRegistrationSlice.actions
export default preRegistrationSlice.reducer
